import React from "react";
import "../../css/sharedStyles.css";
import "./comicDetail.css";
import ComicCreators from "./ComicCreators.js";

var ComicDetail = class ComicDetail extends React.Component{
    
    render() {
      const inlineStyle = {
        marginBottom:"10px",
        marginTop:"0",
        width:'100%',
        paddingTop:'10px',
        paddingBottom:'10px'
      }

      return (
        <div>

            <div className="comicDetail" id="desktopDescriptionArea"> 

                    <div className="content_box_square textBoxWidth" style = {inlineStyle}>
                        <h1 className="characterName">{this.props.mainComicInfo.comicTitle}</h1>
                        <p className="characterDescription">{this.props.mainComicInfo.comicDescription}</p>
                   
                        <ComicCreators mainComicInfo = {this.props.mainComicInfo} textStyle ={"creatorsContainerDesktop"}/>
                   
                    </div>

                    
                    
            </div>

        </div>
      );
    }
  }

  export default ComicDetail;


// WEBPACK FOOTER //
// ./src/components/comicDetail/ComicDetailDesktop.js